// @ts-ignore
var $d5909c9e2a02acdc$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(u) {
                    return n(r, t, u);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(u) {
                    return function(e) {
                        return n(r, t, u, e);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(u) {
                    return function(e) {
                        return function(i) {
                            return n(r, t, u, e, i);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(u) {
                    return function(e) {
                        return function(i) {
                            return function(o) {
                                return n(r, t, u, e, i, o);
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, u) {
        return 3 === n.a ? n.f(r, t, u) : n(r)(t)(u);
    }
    function A4(n, r, t, u, e) {
        return 4 === n.a ? n.f(r, t, u, e) : n(r)(t)(u)(e);
    }
    function A5(n, r, t, u, e, i) {
        return 5 === n.a ? n.f(r, t, u, e, i) : n(r)(t)(u)(e)(i);
    }
    function A6(n, r, t, u, e, i, o) {
        return 6 === n.a ? n.f(r, t, u, e, i, o) : n(r)(t)(u)(e)(i)(o);
    }
    var t = {
        $: 0
    };
    function u(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var e = F2(u);
    function i(n) {
        for(var r = t, e = n.length; e--;)r = u(n[e], r);
        return r;
    }
    var o = F3(function(n, r, t) {
        for(var u = []; r.b && t.b; r = r.b, t = t.b)u.push(A2(n, r.a, t.a));
        return i(u);
    }), c = F3(function(n, r, t) {
        for(var u = Array(n), e = 0; n > e; e++)u[e] = t(r + e);
        return u;
    }), f = F2(function(n, r) {
        for(var t = Array(n), u = 0; n > u && r.b; u++)t[u] = r.a, r = r.b;
        return t.length = u, v(t, r);
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function s(n, r, t, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        if (t > 100) return u.push(v(n, r)), !0;
        for(var e in 0 > n.$ && (n = dn(n), r = dn(r)), n)if (!s(n[e], r[e], t + 1, u)) return !1;
        return !0;
    }
    function b(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = b(n.a, r.a)) || (t = b(n.b, r.b)) ? t : b(n.c, r.c);
        for(; n.b && r.b && !(t = b(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var l = F2(function(n, r) {
        var t = b(n, r);
        return 0 > t ? bn : t ? hn : sn;
    });
    function v(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function d(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    var h = F2($);
    function $(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = u(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = u(n.a, r);
        return t;
    }
    var g = Math.ceil, p = Math.floor, y = Math.log, m = F2(function(n, r) {
        return r.split(n);
    }), w = F2(function(n, r) {
        return r.join(n);
    }), x = F2(function(n, r) {
        for(var t = r.length; t--;){
            var u = r[t], e = r.charCodeAt(t);
            if (56320 > e || e > 57343 || (u = r[--t] + u), !n(u)) return !1;
        }
        return !0;
    }), A = F2(function(n, r) {
        return r.indexOf(n) > -1;
    });
    function O(n) {
        return n + "";
    }
    function T(n) {
        return {
            $: 2,
            b: n
        };
    }
    var j = T(function(n) {
        return "number" != typeof n ? M("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? wn(n) : !isFinite(n) || n % 1 ? M("an INT", n) : wn(n);
    }), E = T(function(n) {
        return "boolean" == typeof n ? wn(n) : M("a BOOL", n);
    }), N = T(function(n) {
        return "number" == typeof n ? wn(n) : M("a FLOAT", n);
    }), k = T(function(n) {
        return wn(n);
    }), C = T(function(n) {
        return "string" == typeof n ? wn(n) : n instanceof String ? wn(n + "") : M("a STRING", n);
    }), J = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function L(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var R = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), S = F2(function(n, r) {
        return L(n, [
            r
        ]);
    }), q = F3(function(n, r, t) {
        return L(n, [
            r,
            t
        ]);
    }), F = F4(function(n, r, t, u) {
        return L(n, [
            r,
            t,
            u
        ]);
    }), P = F5(function(n, r, t, u, e) {
        return L(n, [
            r,
            t,
            u,
            e
        ]);
    }), _ = F6(function(n, r, t, u, e, i) {
        return L(n, [
            r,
            t,
            u,
            e,
            i
        ]);
    }), B = F2(function(n, r) {
        try {
            return I(n, JSON.parse(r));
        } catch (n) {
            return gn(A2(pn, "This is not valid JSON! " + n.message, r));
        }
    }), D = F2(function(n, r) {
        return I(n, r);
    });
    function I(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? wn(n.c) : M("null", r);
            case 3:
                return z(r) ? X(n.b, r, i) : M("a LIST", r);
            case 4:
                return z(r) ? X(n.b, r, G) : M("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return M("an OBJECT with a field named `" + e + "`", r);
                var o = I(n.b, r[e]);
                return ar(o) ? o : gn(A2(yn, e, o.a));
            case 7:
                var c = n.e;
                return z(r) ? r.length > c ? (o = I(n.b, r[c]), ar(o) ? o : gn(A2(mn, c, o.a))) : M("a LONGER array. Need index " + c + " but only see " + r.length + " entries", r) : M("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || z(r)) return M("an OBJECT", r);
                var f = t;
                for(var a in r)if (r.hasOwnProperty(a)) {
                    if (o = I(n.b, r[a]), !ar(o)) return gn(A2(yn, a, o.a));
                    f = u(v(a, o.a), f);
                }
                return wn(Xn(f));
            case 9:
                for(var s = n.f, b = n.g, l = 0; b.length > l; l++){
                    if (o = I(b[l], r), !ar(o)) return o;
                    s = s(o.a);
                }
                return wn(s);
            case 10:
                return o = I(n.b, r), ar(o) ? I(n.h(o.a), r) : o;
            case 11:
                for(var d = t, h = n.g; h.b; h = h.b){
                    if (o = I(h.a, r), ar(o)) return o;
                    d = u(o.a, d);
                }
                return gn(xn(Xn(d)));
            case 1:
                return gn(A2(pn, n.a, r));
            case 0:
                return wn(n.a);
        }
    }
    function X(n, r, t) {
        for(var u = r.length, e = Array(u), i = 0; u > i; i++){
            var o = I(n, r[i]);
            if (!ar(o)) return gn(A2(mn, i, o.a));
            e[i] = o.a;
        }
        return wn(t(e));
    }
    function z(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function G(n) {
        return A2(fr, n.length, function(r) {
            return n[r];
        });
    }
    function M(n, r) {
        return gn(A2(pn, "Expecting " + n, r));
    }
    var Q = F2(function(n, r) {
        return JSON.stringify(r, null, n) + "";
    });
    function Y(n) {
        return n;
    }
    var H = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), W = 0;
    var K = !1, U = [];
    function V(n) {
        if (U.push(n), !K) {
            for(K = !0; n = U.shift();)Z(n);
            K = !1;
        }
    }
    function Z(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, V(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var nn = F4(function(n, r, t, u) {
        return function(n, r, t, u, e) {
            var i = A2(D, n, r ? r.flags : void 0);
            ar(i) || a(2);
            var o = {}, c = t(i.a), f = c.a, s = function() {}, b = function(n, r) {
                var t;
                for(var u in rn){
                    var e = rn[u];
                    e.a && ((t = t || {})[u] = e.a(u, r)), n[u] = tn(e, r);
                }
                return t;
            }(o, l);
            function l(n, r) {
                var t = A2(u, n, f);
                s(f = t.a, r), on(o, t.b, e(f));
            }
            return on(o, c.b, e(f)), b ? {
                ports: b
            } : {};
        }(r, u, n.av, n.aD, n.aB);
    }), rn = {};
    function tn(n, r) {
        var t, u = {
            g: r,
            h: void 0
        }, e = n.c, i = n.d, o = n.e, c = n.f;
        function f(n) {
            return A2(H, f, {
                $: 5,
                b: function(r) {
                    var t = r.a;
                    return 0 === r.$ ? A3(i, u, t, n) : o && c ? A4(e, u, t.i, t.j, n) : A3(e, u, o ? t.i : t.j, n);
                }
            });
        }
        return u.h = (V(t = {
            $: 0,
            e: W++,
            f: A2(H, f, n.b),
            g: null,
            h: []
        }), t);
    }
    var un = [], en = !1;
    function on(n, r, t) {
        if (un.push({
            p: n,
            q: r,
            r: t
        }), !en) {
            en = !0;
            for(var u; u = un.shift();)cn(u.p, u.q, u.r);
            en = !1;
        }
    }
    function cn(n, r, u) {
        var e, i = {};
        for(var o in fn(!0, r, i, null), fn(!1, u, i, null), n)(e = n[o]).h.push({
            $: "fx",
            a: i[o] || {
                i: t,
                j: t
            }
        }), V(e);
    }
    function fn(n, r, e, i) {
        switch(r.$){
            case 1:
                var o = r.k, c = function(n, r, t, u) {
                    function e(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? rn[r].e : rn[r].f, e, u);
                }(n, o, i, r.l);
                return void (e[o] = function(n, r, e) {
                    return e = e || {
                        i: t,
                        j: t
                    }, n ? e.i = u(r, e.i) : e.j = u(r, e.j), e;
                }(n, c, e[o]));
            case 2:
                for(var f = r.m; f.b; f = f.b)fn(n, f.a, e, i);
                return;
            case 3:
                return void fn(n, r.o, e, {
                    s: r.n,
                    t: i
                });
        }
    }
    var an = F2(function(n, r) {
        return r;
    });
    var sn = 1, bn = 0, ln = e, vn = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var u = t.d, e = n, i = A3(n, t.b, t.c, A3(vn, n, r, t.e));
            n = e, r = i, t = u;
        }
    }), dn = function(n) {
        return A3(vn, F3(function(n, r, t) {
            return A2(ln, v(n, r), t);
        }), t, n);
    }, hn = 2, $n = F3(function(n, r, t) {
        return r(n(t));
    }), gn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, pn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), yn = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mn = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), wn = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xn = function(n) {
        return {
            $: 2,
            a: n
        };
    }, An = function(n) {
        return {
            $: 0,
            a: n
        };
    }, On = {
        $: 1
    }, Tn = x, jn = h, En = Q, Nn = O, kn = F2(function(n, r) {
        return A2(w, n, function(n) {
            for(var r = []; n.b; n = n.b)r.push(n.a);
            return r;
        }(r));
    }), Cn = F2(function(n, r) {
        return i(A2(m, n, r));
    }), Jn = function(n) {
        return A2(kn, "\n    ", A2(Cn, "\n", n));
    }, Ln = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var u = t.b, e = n, i = A2(n, t.a, r);
            n = e, r = i, t = u;
        }
    }), Rn = function(n) {
        return A3(Ln, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Sn = o, qn = F3(function(n, r, t) {
        for(;;){
            if (b(n, r) >= 1) return t;
            var u = n, e = r - 1, i = A2(ln, r, t);
            n = u, r = e, t = i;
        }
    }), Fn = F2(function(n, r) {
        return A3(qn, n, r, t);
    }), Pn = F2(function(n, r) {
        return A3(Sn, n, A2(Fn, 0, Rn(r) - 1), r);
    }), _n = function(n) {
        var r = n.charCodeAt(0);
        return 55296 > r || r > 56319 ? r : 1024 * (r - 55296) + n.charCodeAt(1) - 56320 + 65536;
    }, Bn = function(n) {
        var r = _n(n);
        return r >= 97 && 122 >= r;
    }, Dn = function(n) {
        var r = _n(n);
        return 90 >= r && r >= 65;
    }, In = function(n) {
        return Bn(n) || Dn(n) || function(n) {
            var r = _n(n);
            return 57 >= r && r >= 48;
        }(n);
    }, Xn = function(n) {
        return A3(Ln, ln, t, n);
    }, zn = F2(function(n, r) {
        return "\n\n(" + Nn(n + 1) + ") " + Jn(Gn(r));
    }), Gn = function(n) {
        return A2(Mn, n, t);
    }, Mn = F2(function(n, r) {
        n: for(;;)switch(n.$){
            case 0:
                var t = n.a, u = n.b, e = function() {
                    var n, r, u = (r = (n = t).charCodeAt(0), isNaN(r) ? On : An(55296 > r || r > 56319 ? v(n[0], n.slice(1)) : v(n[0] + n[1], n.slice(2))));
                    if (1 === u.$) return !1;
                    var e, i = u.a, o = i.b;
                    return (Bn(e = i.a) || Dn(e)) && A2(Tn, In, o);
                }();
                n = u, r = A2(ln, e ? "." + t : "['" + t + "']", r);
                continue n;
            case 1:
                u = n.b;
                var i = "[" + Nn(n.a) + "]";
                n = u, r = A2(ln, i, r);
                continue n;
            case 2:
                var o = n.a;
                if (o.b) {
                    if (o.b.b) {
                        var c = (r.b ? "The Json.Decode.oneOf at json" + A2(kn, "", Xn(r)) : "Json.Decode.oneOf") + " failed in the following " + Nn(Rn(o)) + " ways:";
                        return A2(kn, "\n\n", A2(ln, c, A2(Pn, zn, o)));
                    }
                    n = u = o.a;
                    continue n;
                }
                return "Ran into a Json.Decode.oneOf with no possibilities" + (r.b ? " at json" + A2(kn, "", Xn(r)) : "!");
            default:
                var f = n.a, a = n.b;
                return (c = r.b ? "Problem with the value at json" + A2(kn, "", Xn(r)) + ":\n\n    " : "Problem with the given value:\n\n") + Jn(A2(En, 4, a)) + "\n\n" + f;
        }
    }), Qn = 32, Yn = F4(function(n, r, t, u) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: u
        };
    }), Hn = [], Wn = g, Kn = F2(function(n, r) {
        return y(r) / y(n);
    }), Un = Wn(A2(Kn, 2, Qn)), Vn = A4(Yn, 0, Un, Hn, Hn), Zn = c, nr = p, rr = function(n) {
        return n.length;
    }, tr = F2(function(n, r) {
        return b(n, r) > 0 ? n : r;
    }), ur = f, er = F2(function(n, r) {
        for(;;){
            var t = A2(ur, Qn, n), u = t.b, e = A2(ln, {
                $: 0,
                a: t.a
            }, r);
            if (!u.b) return Xn(e);
            n = u, r = e;
        }
    }), ir = F2(function(n, r) {
        for(;;){
            var u = Wn(r / Qn);
            if (1 === u) return A2(ur, Qn, n).a;
            n = A2(er, n, t), r = u;
        }
    }), or = F2(function(n, r) {
        if (r.a) {
            var t = r.a * Qn, u = nr(A2(Kn, Qn, t - 1)), e = n ? Xn(r.d) : r.d, i = A2(ir, e, r.a);
            return A4(Yn, rr(r.c) + t, A2(tr, 5, u * Un), i, r.c);
        }
        return A4(Yn, rr(r.c), Un, Hn, r.c);
    }), cr = F5(function(n, r, t, u, e) {
        for(;;){
            if (0 > r) return A2(or, !1, {
                d: u,
                a: t / Qn | 0,
                c: e
            });
            var i = {
                $: 1,
                a: A3(Zn, Qn, r, n)
            };
            r -= Qn, u = A2(ln, i, u);
        }
    }), fr = F2(function(n, r) {
        if (n > 0) {
            var u = n % Qn;
            return A5(cr, r, n - u - Qn, n, t, A3(Zn, u, n - u, r));
        }
        return Vn;
    }), ar = function(n) {
        return !n.$;
    }, sr = B, br = q, lr = {
        $: -2
    }, vr = lr, dr = F5(function(n, r, t, u, e) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: u,
            e: e
        };
    }), hr = F5(function(n, r, t, u, e) {
        if (-1 !== e.$ || e.a) {
            if (-1 !== u.$ || u.a || -1 !== u.d.$ || u.d.a) return A5(dr, n, r, t, u, e);
            var i = u.d;
            return o = u.e, A5(dr, 0, u.b, u.c, A5(dr, 1, i.b, i.c, i.d, i.e), A5(dr, 1, r, t, o, e));
        }
        var o, c = e.b, f = e.c, a = e.d, s = e.e;
        return -1 !== u.$ || u.a ? A5(dr, n, c, f, A5(dr, 0, r, t, u, a), s) : A5(dr, 0, r, t, A5(dr, 1, u.b, u.c, u.d, o = u.e), A5(dr, 1, c, f, a, s));
    }), $r = l, gr = F3(function(n, r, t) {
        if (-2 === t.$) return A5(dr, 0, n, r, lr, lr);
        var u = t.a, e = t.b, i = t.c, o = t.d, c = t.e;
        switch(A2($r, n, e)){
            case 0:
                return A5(hr, u, e, i, A3(gr, n, r, o), c);
            case 1:
                return A5(dr, u, e, r, o, c);
            default:
                return A5(hr, u, e, i, o, A3(gr, n, r, c));
        }
    }), pr = F3(function(n, r, t) {
        var u = A3(gr, n, r, t);
        return -1 !== u.$ || u.a ? u : A5(dr, 1, u.b, u.c, u.d, u.e);
    }), yr = function(n) {
        return A3(Ln, F2(function(n, r) {
            return A3(pr, n.a, n.b, r);
        }), vr, n);
    }, mr = S, wr = function(n) {
        return A2(mr, yr, function(n) {
            return {
                $: 8,
                b: n
            };
        }(n));
    }, xr = J, Ar = function(n) {
        return {
            $: 3,
            b: n
        };
    }, Or = F4(function(n, r, t, u) {
        if (u.b) {
            var e = u.a, i = u.b;
            if (i.b) {
                var o = i.a, c = i.b;
                if (c.b) {
                    var f = c.a, a = c.b;
                    if (a.b) {
                        var s = a.b;
                        return A2(n, e, A2(n, o, A2(n, f, A2(n, a.a, t > 500 ? A3(Ln, n, r, Xn(s)) : A4(Or, n, r, t + 1, s)))));
                    }
                    return A2(n, e, A2(n, o, A2(n, f, r)));
                }
                return A2(n, e, A2(n, o, r));
            }
            return A2(n, e, r);
        }
        return r;
    }), Tr = F3(function(n, r, t) {
        return A4(Or, n, r, 0, t);
    }), jr = F2(function(n, r) {
        return A3(Tr, F2(function(r, t) {
            return A2(ln, n(r), t);
        }), t, r);
    }), Er = function(n) {
        return {
            $: 11,
            g: n
        };
    }, Nr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, kr = function(n) {
        return Er(i([
            A2(mr, An, n),
            Nr(On)
        ]));
    }, Cr = F2(function(n, r) {
        return v(n, r);
    }), Jr = C, Lr = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Rr = function(n) {
        return A2(mr, Lr(""), kr(A2(xr, "meta", A2(mr, A2($n, dn, A2($n, jr(function(n) {
            var r = n.a, t = n.b, u = t.b;
            return t.a ? r + ": " + u : r + "\n" + u + "\n@end";
        }), A2($n, kn("\n\n"), function(r) {
            return n ? "\x3c!--\n\n" + r + "\n\n--\x3e\n\n\n" : "\n\x3c!--\n" + r + "\n--\x3e";
        }))), wr(Er(i([
            A2(mr, Cr(!0), Jr),
            A2(mr, A2($n, kn("\n"), Cr(!1)), Ar(Jr))
        ])))))));
    }, Sr = function(n) {
        return "" === n;
    }, qr = E, Fr = N, Pr = O, _r = j, Br = k, Dr = kr(A2(xr, "attr", Er(i([
        Jr,
        A2(mr, A2($n, dn, A2($n, jr(function(n) {
            return n.a + '="' + n.b + '"';
        }), kn(" "))), wr(Er(i([
            Jr,
            A2(mr, Nn, _r),
            A2(mr, Pr, Fr),
            A2(mr, function(n) {
                return n ? "true" : "false";
            }, qr),
            A2(mr, En(0), Br)
        ]))))
    ])))), Ir = F2(function(n, r) {
        return r.$ ? On : An(n(r.a));
    }), Xr = A2(mr, A2($n, Ir(function(n) {
        return "\x3c!-- " + n + " --\x3e";
    }), Lr("")), Dr), zr = function(n) {
        return A2(mr, function(r) {
            return Sr(r) ? n : r + "\n" + n;
        }, Xr);
    }, Gr = function(n) {
        return i(n.split(/\r\n|\r|\n/g));
    }, Mr = F2(function(n, r) {
        return A2(kn, "\n", A2(jr, function(r) {
            return $(n, r);
        }, Gr(r)));
    }), Qr = R, Yr = function(n) {
        return A2(mr, function(r) {
            return $(n, r);
        }, Xr);
    }, Hr = _, Wr = A2(mr, Lr(!1), kr(A2(xr, "playback", qr))), Kr = A2(mr, Ir(Nn), kr(A2(xr, "start", _r))), Ur = A2(mr, Ir(Nn), kr(A2(xr, "stop", _r))), Vr = kr(A2(xr, "voice", Jr)), Zr = function(n) {
        return A6(Hr, F5(function(n, r, t, u, e) {
            var i, o, c, f = (o = v(r, t)).a.$ ? On : An(1 === o.b.$ ? o.a.a : o.a.a + "-" + o.b.a), a = (i = v(u, e)).a ? An(1 === i.b.$ ? "!>" : "!> " + i.b.a) : On;
            return v(1 === (c = v(f, a)).a.$ ? c.b.$ ? "" : c.b.a : 1 === c.b.$ ? c.a.a : c.a.a + " " + c.b.a, n);
        }), n, Kr, Ur, Wr, Vr);
    }, nt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, rt = F, tt = F2(function(n, r) {
        return A4(rt, F3(function(r, t, u) {
            return "<" + r + " " + A2(Lr, "", u) + ">" + A2(Lr, "", n) + t + A2(Lr, "", n) + "</" + r + ">";
        }), A2(xr, "htmlTag", Jr), r, Dr);
    }), ut = function(n) {
        return n.length;
    }, et = F3(function(n, r, t) {
        return n > 0 ? A3(et, n >> 1, $(r, r), 1 & n ? $(t, r) : t) : t;
    }), it = F2(function(n, r) {
        return A3(et, n, r, "");
    }), ot = A2(Qr, function(n) {
        var r = n.a, t = n.b;
        if (1 === t.$) return Nr(r);
        var u = t.a;
        return 0 > b(u, ut(r)) ? nt("length must be greater than or equal to the length of the solution") : Nr($(r, A2(it, u - ut(r), " ")));
    }, A3(br, Cr, A2(xr, "solution", Jr), kr(A2(xr, "length", _r)))), ct = P, ft = F3(function(n, r, t) {
        var u = n(r);
        return u.$ ? t : A2(ln, u.a, t);
    }), at = F2(function(n, r) {
        return A3(Tr, ft(n), t, r);
    }), st = function(n) {
        return i([
            n
        ]);
    }, bt = Er(i([
        A2(mr, st, _r),
        Ar(_r),
        A2(mr, A2($n, Pn(Cr), at(function(n) {
            return n.b ? An(n.a) : On;
        })), Ar(qr))
    ])), lt = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), vt = F2(function(n, r) {
        return A2(lt, function(r) {
            return function(n, r) {
                for(var t, u = [], e = s(n, r, 0, u); e && (t = u.pop()); e = s(t.a, t.b, 0, u));
                return e;
            }(r, n);
        }, r);
    }), dt = Er(i([
        Jr,
        A2(mr, kn("\n"), Ar(Jr))
    ])), ht = function(n) {
        switch(n){
            case "bold":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "__" + n + "__";
                }, $t()));
            case "italic":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "_" + n + "_";
                }, $t()));
            case "formula":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "$ " + n + " $";
                }, $t()));
            case "symbol":
            case "string":
                return A2(Qr, Yr, A2(xr, "body", Jr));
            case "strike":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "~" + n + "~";
                }, $t()));
            case "sup":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "^" + n + "^";
                }, $t()));
            case "underline":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "~~" + n + "~~";
                }, $t()));
            case "code":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "`" + n + "`";
                }, A2(xr, "body", Jr)));
            case "effect":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "{" + n.a + "}{" + n.b + "}";
                }, Zr($t())));
            case "footnote":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "[^" + n + "]";
                }, A2(xr, "body", Jr)));
            case "html":
                return A2(tt, On, $t());
            case "link":
                return pt();
            case "multimedia":
                return gt();
            case "script":
                return A3(br, F2(function(n, r) {
                    return "<script " + A2(Lr, "", r) + ">" + n + "<\/script>";
                }), A2(xr, "body", dt), Dr);
            case "input":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "[[" + n + "]]";
                }, ot));
            case "select":
                return A2(Qr, Yr, A2(mr, function(n) {
                    return "[[ " + n + " ]]";
                }, yt()));
            default:
                return nt("unknown inline type " + n);
        }
    };
    function $t() {
        return A2(xr, "body", wt());
    }
    function gt() {
        return A2(Qr, Yr, A5(ct, F4(function(n, r, t, u) {
            return Sr(n) && Sr(r) ? t : n + "[" + r + "](" + t + u + ")";
        }), A2(xr, "embedType", A2(Qr, function(n) {
            switch(n){
                case "image":
                    return Nr("!");
                case "audio":
                    return Nr("?");
                case "video":
                    return Nr("!?");
                case "embed":
                    return Nr("??");
                default:
                    return nt("Only image, audio, video, and embed are supported");
            }
        }, Jr)), A2(mr, Lr(""), kr(A2(xr, "alt", wt()))), A2(xr, "url", Jr), A2(mr, A2($n, Ir(function(n) {
            return ' "' + n + '"';
        }), Lr("")), kr(A2(xr, "title", wt())))));
    }
    function pt() {
        return A2(Qr, Yr, A4(rt, F3(function(n, r, t) {
            var u = v(n, t);
            return "" === u.a ? "" === u.b ? r : "[" + r + "](" + r + t + ")" : "" === u.b ? "[" + n + "](" + r + ")" : "[" + n + "](" + r + t + ")";
        }), A2(mr, Lr(""), kr(A2(xr, "body", wt()))), A2(xr, "url", Jr), A2(mr, A2($n, Ir(function(n) {
            return ' "' + n + '"';
        }), Lr("")), kr(A2(xr, "title", wt())))));
    }
    function yt() {
        return A3(br, F2(function(n, r) {
            return A2(kn, " | ", A2(Pn, F2(function(n, t) {
                return A2(vt, n, r) ? "( " + t + " )" : t;
            }), n));
        }), mt(), A2(xr, "solution", bt));
    }
    function mt() {
        return A2(xr, "body", Ar(wt()));
    }
    function wt() {
        var n;
        return Er(i([
            Jr,
            A2(Qr, ht, A2(xr, "type", Jr)),
            A2(mr, kn(""), (n = function() {
                return Ar(wt());
            }, A2(Qr, n, Nr(0))))
        ]));
    }
    var xt = $t();
    $t = function() {
        return xt;
    };
    var At = gt();
    gt = function() {
        return At;
    };
    var Ot = pt();
    pt = function() {
        return Ot;
    };
    var Tt = yt();
    yt = function() {
        return Tt;
    };
    var jt = mt();
    mt = function() {
        return jt;
    };
    var Et = wt();
    wt = function() {
        return Et;
    };
    var Nt = A3(br, F2(function(n, r) {
        return "``` ascii" + r + "\n" + n + "\n```";
    }), A2(xr, "body", dt), A2(mr, A2($n, Ir(jn("  ")), Lr("")), kr(A2(xr, "title", Et)))), kt = A2(mr, Mr("    "), A2(xr, "body", dt)), Ct = A5(ct, F4(function(n, r, t, u) {
        var e = d(r, t, u);
        return e.a.$ ? "```\n" + n + "\n```" : 1 === e.b.$ ? "``` " + e.a.a + "\n" + n + "\n```" : 1 === e.c.$ ? "``` " + e.a.a + "   " + e.b.a + "\n" + n + "\n```" : "``` " + e.a.a + "   " + (e.c.a ? "-" : "+") + e.b.a + "\n" + n + "\n```";
    }), A2(xr, "body", dt), kr(A2(xr, "language", Jr)), kr(A2(xr, "title", Jr)), kr(A2(xr, "closed", qr))), Jt = A, Lt = A2(mr, function(n) {
        return 1 === n.$ ? "" : "<script>" + n.a + "\n<\/script>";
    }, kr(A2(mr, function(n) {
        return "\n" + n;
    }, A2(xr, "execute", dt)))), Rt = A2($n, Pn(function(n) {
        return A2($n, Gr, A2($n, Pn(F2(function(r, t) {
            return r ? "   " + t : Nn(n + 1) + ". " + t;
        })), kn("\n")));
    }), kn("\n\n")), St = A3(br, F2(function(n, r) {
        return $(A2(kn, "\n", n), r);
    }), A2(xr, "body", Ar(Ct)), Lt), qt = kr(A2(xr, "hints", A2(mr, A2($n, jr(jn("[[?]] ")), kn("\n")), Ar(Et)))), Ft = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(ln, t, n), r -= 1;
        }
    }), Pt = F2(function(n, r) {
        return A3(Ft, t, n, r);
    }), _t = A4(rt, F3(function(n, r, t) {
        var u = A2(Lr, A2(Pt, Rn(n), "-----"), A2(Ir, jr(function(n) {
            switch(n){
                case "left":
                    return ":----";
                case "right":
                    return "----:";
                case "center":
                    return ":---:";
                default:
                    return "-----";
            }
        }), r));
        return A2(kn, "\n", A2(jr, function(n) {
            return "| " + n + " |";
        }, $(i([
            A2(kn, " | ", n)
        ]), $(i([
            A2(kn, " | ", u)
        ]), A2(jr, kn(" | "), t)))));
    }), A2(xr, "head", Ar(Et)), kr(A2(xr, "alignment", Ar(Jr))), A2(xr, "body", Ar(Ar(Et)))), Bt = A4(rt, F3(function(n, r, t) {
        return $(A2(kn, "\n", A2(Pn, F2(function(n, t) {
            return A2(vt, n, r) ? "- [X] " + t : "- [ ] " + t;
        }), n)), t);
    }), A2(xr, "body", Ar(Et)), A2(mr, Lr(t), kr(A2(xr, "done", bt))), Lt), Dt = A2($n, jr(A2($n, Gr, A2($n, Pn(F2(function(n, r) {
        return n ? "  " + r : "* " + r;
    })), kn("\n")))), kn("\n\n")), It = function(n) {
        switch(n){
            case "Paragraph":
                return A2(Qr, zr, A2(xr, "body", Et));
            case "Line":
                return zr("---");
            case "Comment":
                return A2(Qr, zr, A4(rt, F3(function(n, r, t) {
                    return "--{{" + n + (1 === r.$ ? "" : " " + r.a) + "}}--\n" + t;
                }), A2(Qr, function(n) {
                    return n.$ ? nt("a comment requires start parameter") : Nr(n.a);
                }, Kr), Vr, A2(xr, "body", Et)));
            case "Gallery":
                return A2(Qr, zr, A2(mr, kn("\n"), A2(xr, "body", Ar(At))));
            case "Formula":
                return A2(Qr, zr, A2(mr, function(n) {
                    return "$$ " + n + " $$";
                }, A2(xr, "body", dt)));
            case "Effect":
                return A2(Qr, zr, Er(i([
                    A2(mr, function(n) {
                        return "{{" + n.a + "}}\n" + n.b;
                    }, Zr(A2(xr, "body", Yt()))),
                    A2(Qr, function(n) {
                        return n.b ? n.b.b ? A2(mr, function(n) {
                            return "{{" + n.a + "}}\n**********************\n\n" + n.b + "\n\n**********************";
                        }, Zr(Nr(A2(kn, "\n\n", n)))) : A2(mr, function(n) {
                            return "{{" + n.a + "}}\n" + n.b;
                        }, Zr(Nr(n.a))) : nt("An effect must have at least one block.");
                    }, A2(xr, "body", Ar(Yt())))
                ])));
            case "Quote":
                return A2(Qr, zr, zt());
            case "Html":
                return A2(tt, An("\n\n"), Xt());
            case "Ascii":
                return A2(Qr, zr, Nt);
            case "Chart":
                return A2(Qr, zr, kt);
            case "Table":
                return A2(Qr, zr, _t);
            case "List":
                return A2(Qr, zr, A2(Qr, function(n) {
                    return A2(mr, n ? Rt : Dt, A2(xr, "body", Ar(Er(i([
                        Qt(),
                        Yt()
                    ])))));
                }, A2(mr, Lr(!1), kr(A2(xr, "ordered", qr)))));
            case "Code":
                return A2(Qr, zr, A3(br, F2(function(n, r) {
                    return Sr(r) ? n : n + "\n" + r;
                }), Ct, Lt));
            case "Project":
                return A2(Qr, zr, St);
            case "Tasks":
                return A2(Qr, zr, Bt);
            case "Quiz":
                return A2(Qr, zr, Gt());
            default:
                return Et;
        }
    };
    function Xt() {
        return A2(xr, "body", Er(i([
            Yt(),
            A2(mr, kn("\n\n"), Ar(Yt())),
            dt
        ])));
    }
    function zt() {
        return A3(br, F2(function(n, r) {
            return A2(Mr, "> ", 1 === r.$ ? n : n + "\n\n-- " + r.a);
        }), A2(xr, "body", Er(i([
            Yt(),
            Qt()
        ]))), kr(A2(xr, "by", Qt())));
    }
    function Gt() {
        return A5(ct, F4(function(n, r, t, u) {
            return $(n, 1 === r.$ ? $(t, u) : $(r.a, $(t, u)));
        }), Ht(), qt, Mt(), Lt);
    }
    function Mt() {
        return A2(mr, Lr(""), kr(A2(mr, function(n) {
            return "\n************************\n\n" + n + "\n\n************************";
        }, A2(xr, "answer", Qt()))));
    }
    function Qt() {
        return A2(mr, kn("\n\n"), Ar(Yt()));
    }
    function Yt() {
        return Er(i([
            Jr,
            Et,
            A2(Qr, It, A2(xr, "type", Jr))
        ]));
    }
    function Ht() {
        return A2(Qr, function(n) {
            switch(n){
                case "input":
                    return A2(mr, function(n) {
                        return "[[" + n + "]]\n";
                    }, ot);
                case "selection":
                    return A2(mr, function(n) {
                        return "[[" + n + "]]\n";
                    }, Tt);
                case "single-choice":
                    return A3(br, F2(function(n, r) {
                        return A2(kn, "\n", A2(Pn, F2(function(n, t) {
                            return A2(vt, n, r) ? "[(X)] " + t : "[( )] " + t;
                        }), n)) + "\n";
                    }), jt, A2(xr, "solution", bt));
                case "multiple-choice":
                    return A3(br, F2(function(n, r) {
                        return A2(kn, "\n", A2(Pn, F2(function(n, t) {
                            return A2(vt, n, r) ? "[[X]] " + t : "[[ ]] " + t;
                        }), n)) + "\n";
                    }), jt, A2(xr, "solution", bt));
                case "matrix":
                    return A3(br, F2(function(n, r) {
                        return "[ " + A2(kn, " ", A2(jr, function(n) {
                            return A2(Jt, ")", n) ? "[ " + n + " ]" : "( " + n + " )";
                        }, n)) + " ]\n" + A2(kn, "\n", A2(jr, function(r) {
                            var t = r.a, u = r.b, e = r.c;
                            return "[  " + A2(kn, " ", A2(Pn, F2(function(n) {
                                return A2(vt, n, u) ? t ? "(X)" : "[X]" : t ? "( )" : "[ ]";
                            }), n)) + "  ] " + e;
                        }, r)) + "\n";
                    }), A2(xr, "head", Ar(Er(i([
                        Et,
                        Et
                    ])))), A2(xr, "body", Ar(Er(i([
                        A2(xr, "single-choice", A3(br, F2(function(n, r) {
                            return d(!0, n, r);
                        }), A2(xr, "solution", bt), A2(xr, "body", Et))),
                        A2(xr, "multiple-choice", A3(br, F2(function(n, r) {
                            return d(!1, n, r);
                        }), A2(xr, "solution", bt), A2(xr, "body", Et)))
                    ])))));
                case "gap-text":
                    return A2(xr, "body", Yt());
                case "generic":
                    return Nr("[[!]]\n");
                default:
                    return nt('Supported quiz types are "input", "selection", "single-choice", "multiple-choice", "matrix", "gap-text", and "generic".');
            }
        }, A2(xr, "quizType", Jr));
    }
    var Wt = Xt();
    Xt = function() {
        return Wt;
    };
    var Kt = zt();
    zt = function() {
        return Kt;
    };
    var Ut = Gt();
    Gt = function() {
        return Ut;
    };
    var Vt = Mt();
    Mt = function() {
        return Vt;
    };
    var Zt = Qt();
    Qt = function() {
        return Zt;
    };
    var nu = Yt();
    Yt = function() {
        return nu;
    };
    var ru = Ht();
    Ht = function() {
        return ru;
    };
    var tu, uu, eu, iu, ou = A2(xr, "body", Er(i([
        nu,
        Zt
    ]))), cu = A2(Qr, function(n) {
        return n > 0 && 7 > n ? Nr(A2(it, n, "#")) : nt("Indentation must be between 1 and 6");
    }, A2(xr, "indent", _r)), fu = A3(br, F2(function(n, r) {
        return n + " " + r;
    }), cu, A2(xr, "title", Et)), au = A4(rt, F3(function(n, r, t) {
        return n + (t + "\n\n") + r;
    }), fu, ou, Rr(!1)), su = A2(mr, kn("\n\n\n"), A2(xr, "sections", Ar(au))), bu = A3(br, F2(function(n, r) {
        return $(n, r);
    }), Rr(!0), su), lu = F2(function(n, r) {
        return r.$ ? gn(n(r.a)) : wn(r.a);
    }), vu = A2($n, sr(bu), lu(Gn)), du = Y, hu = function(n) {
        return n;
    }, $u = F2(function(n, r) {
        return A3(Ln, function(n) {
            return F2(function(r, t) {
                return t.push(n(r)), t;
            });
        }(n), [], r);
    }), gu = Y, pu = (uu = function(n) {
        var r = n.b;
        return A2($u, hu, i([
            du(n.a),
            gu(r)
        ]));
    }, function(n) {
        rn[n] && a(3);
    }(tu = "outPort"), rn[tu] = {
        e: an,
        u: uu,
        a: function(n) {
            var r = [], t = rn[n].u, u = {
                $: 2,
                b: function(n) {
                    var r = setTimeout(function() {
                        n({
                            $: 0,
                            a: 0
                        });
                    }, 0);
                    return function() {
                        clearTimeout(r);
                    };
                },
                c: null
            };
            return rn[n].b = u, rn[n].c = F3(function(n, e) {
                for(; e.b; e = e.b)for(var i = r, o = t(e.a), c = 0; i.length > c; c++)i[c](o);
                return u;
            }), {
                subscribe: function(n) {
                    r.push(n);
                },
                unsubscribe: function(n) {
                    var t = (r = r.slice()).indexOf(n);
                    0 > t || r.splice(t, 1);
                }
            };
        }
    }, iu = tu, function(n) {
        return {
            $: 1,
            k: iu,
            l: n
        };
    }), yu = function(n) {
        var r = vu(n);
        return v({
            E: n,
            F: r
        }, pu(v(!r.$, r.a)));
    }, mu = {
        $: 2,
        m: t
    };
    eu = {
        Worker: {
            init: nn({
                av: yu,
                aB: function() {
                    return mu;
                },
                aD: F2(function(n) {
                    return yu(n);
                })
            })(Jr)(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var u in t)u in r ? "init" == u ? a(6) : n(r[u], t[u]) : r[u] = t[u];
    }(n.Elm, eu) : n.Elm = eu;
}($d5909c9e2a02acdc$exports);


function $95f8302c8cf39dc1$var$liascriptify(json) {
    return new Promise((resolve, reject)=>{
        const app = (0, $d5909c9e2a02acdc$exports.Elm).Worker.init({
            flags: typeof json === 'string' ? json : JSON.stringify(json)
        });
        app.ports.outPort.subscribe(([ok, rslt])=>{
            if (ok) resolve(rslt);
            else reject(rslt);
        });
    });
}
window['LiaScriptify'] = $95f8302c8cf39dc1$var$liascriptify;


//# sourceMappingURL=markdownify.js.map
